// Onboarding (first visit: flows 1 and 2) vs. accueil (every return: flows 13 and 14).
export const FLOW13_TITLE = "Flow 13 — Accueil parent";
export const FLOW13_STEPS = ["Bon retour", "Aide et bilan en attente"];

export const FLOW14_TITLE = "Flow 14 — Accueil élève";
export const FLOW14_STEPS = ["Mes plans d’étude", "Aide et bilan en attente"];

export const FORFAIT_NAMES = { 1: "Essentiel", 2: "Famille", 3: "Famille Plus" };

export const HOME_MESSAGES = [
  {
    key: "x.freeChat",
    flowId: 13,
    step: null,
    label: "Conversation libre (forfait)",
    prompt: "Message tapé librement : la conversation libre est réservée au forfait Plan Étude Famille Plus.",
    text: () => "La conversation libre avec Plan Étude est disponible avec le forfait Plan Étude Famille Plus.",
  },
  {
    key: "x.freeChatSoon",
    flowId: 13,
    step: null,
    label: "Conversation libre (Famille Plus, bientôt)",
    prompt: "Compte Famille Plus : la conversation libre arrive avec l'IA (niveau 3).",
    text: () => "La conversation libre arrive bientôt avec votre forfait Plan Étude Famille Plus. En attendant, utilisez les boutons.",
  },
];
